module.exports = __webpack_public_path__ + "img/1_icn_store_exp.bba729c2.svg";